var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['flex-0 grid p-4 bg-white rounded-b-lg border-gray-300 whitespace-no-wrap border-t items-center gap-2', {
  'overflow-x-auto': _vm.scrollable
}]},[_vm._t("error"),_c('div',{class:['flex gap-2', {
    'justify-between': _vm.split,
    'justify-end': !_vm.split,
  }]},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }